module.exports = __webpack_public_path__ + "img/red_minus.206f6733.svg";